import { siteInfo } from "@/mocks/home";

const HERO_IMAGE =
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1710946455525-LMYZVC7UK7EPVR25HNZX/image-asset.jpeg?format=2500w";

export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src={HERO_IMAGE}
        alt="Hillsborough Garden Club garden landscape"
        title="Hillsborough Garden Club"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50" />

      <div className="relative z-10 w-full text-center px-4 md:px-6 py-32">
        <p className="animate-fade-up text-[11px] md:text-xs uppercase tracking-[0.4em] text-white/85">
          Hillsborough, California
        </p>
        <h1
          className="animate-fade-up mt-6 font-heading font-light text-white text-4xl md:text-6xl lg:text-7xl leading-tight max-w-4xl mx-auto"
          style={{ animationDelay: "0.12s" }}
        >
          Hillsborough Garden Club
        </h1>
        <p
          className="animate-fade-up mt-6 text-base md:text-lg text-white/85 max-w-2xl mx-auto font-body tracking-wide"
          style={{ animationDelay: "0.24s" }}
        >
          {siteInfo.tagline}
        </p>
        <div className="animate-fade-up mt-10 flex items-center justify-center gap-4" style={{ animationDelay: "0.36s" }}>
          <a
            href="#our-mission"
            className="inline-flex items-center gap-2 rounded-md bg-background-50 px-6 py-3 text-sm text-primary-800 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Discover Our Mission
            <i className="ri-arrow-down-line" aria-hidden="true" />
          </a>
          <a
            href="#things-we-like"
            className="inline-flex items-center gap-2 rounded-md border border-white/50 px-6 py-3 text-sm text-white hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            Things We Like
          </a>
        </div>
      </div>

      <a
        href="#our-mission"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/80 hover:text-white transition-colors"
      >
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll Down</span>
        <span className="w-9 h-9 flex items-center justify-center animate-soft-pulse">
          <i className="ri-arrow-down-line text-xl" aria-hidden="true" />
        </span>
      </a>
    </section>
  );
}